module.exports = __webpack_public_path__ + "img/radio.624fde66.svg";